<section class="contacts" id="kontakt">
  <div class="border">
    <div class="contact-text">
      <div class="mobile-element" id="con-mob-ele"></div>
      <h2>
        {{ "home.contact.title" | translate }}
        <hr />
      </h2>
    </div>
    <div class="contacts-options">
      <p>
        Tel:<span class="contact-bold-text">+48 505 050 515</span
        ><a role="button" [copy-text]="'+48505050515'" (copied)="('Skopiowano')"
          ><img class="copy-that" src="assets/Group (1).png" />
        </a>
      </p>
      <p>
        Tel:<span class="contact-bold-text">+48 505 050 525</span
        ><a role="button" [copy-text]="'+48505050525'" (copied)="('Skopiowano')"
          ><img class="copy-that" src="assets/Group (1).png" />
        </a>
      </p>
      <p>
        E-mail<span class="contact-bold-text">omex&#64;omex.pl</span
        ><a
          role="button"
          [copy-text]="'omex@omex.pl'"
          (copied)="('Skopiowano')"
        >
          <img class="copy-that" src="assets/Group (1).png" />
        </a>
      </p>
    </div>
  </div>
</section>

<section class="location">
  <main class="location-main">
    <div class="location-text">
      <div class="mobile-element" id="loca-mob-ele"></div>
      <h2>
        {{ "home.contact.subtitle" | translate }}
        <hr />
      </h2>
    </div>
    <div class="location-desc">
      <p class="address-container">
        ul.Tadeusza Wendy 15
        <a
          role="button"
          [copy-text]="'Gdynia, Tadeusza Wendy 15'"
          (copied)="('Skopiowano')"
          ><img class="location-copy-that" src="assets/Group (1).png"
        /></a>
      </p>
      <p>81-341 Gdynia</p>
    </div>
    <div class="location-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8426.7260403307!2d18.54097814032572!3d54.52433242245023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fda730d8c8bbf5%3A0xfb0eabad01f9e613!2sOmex%20Sp.%20z%20o.o.%20sp.k.!5e0!3m2!1spl!2spl!4v1742204941871!5m2!1spl!2spl"
        width="800"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </main>
</section>

<section class="carousel">
  <div class="carousel-content">
    <div class="marque-rectangle"></div>
    {{ "home.contact.text1" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text2" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text3" | translate }}
  </div>
  <div aria-hidden class="carousel-content">
    <div class="marque-rectangle"></div>
    {{ "home.contact.text1" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text2" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text3" | translate }}
  </div>
  <div aria-hidden class="carousel-content">
    <div class="marque-rectangle"></div>
    {{ "home.contact.text1" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text2" | translate }}
    <div class="marque-rectangle"></div>
    {{ "home.contact.text3" | translate }}
  </div>
</section>

<section class="form">
  <div class="form-description">
    <div class="left-side">
      <div class="mobile-element" id="form-mob-ele"></div>
      <h2 class="whiteTitle">
        {{ "home.form.title" | translate }}
        <hr />
      </h2>
      <div id="confirmationMessage" style="display: none"></div>
    </div>
    <div class="right-side">
      <form
        #contactForm="ngForm"
        (ngSubmit)="submitEmail(contactForm)"
        action="https://api.web3forms.com/submit"
        id="contactForm"
        method="post"
      >
        <h2>{{ "home.form.subtitle" | translate }}</h2>
        <label for="name">{{ "home.form.name" | translate }}</label>
        <div>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="{{ 'home.form.namePlaceholder' | translate }}"
            required
            minlength="2"
            [(ngModel)]="contactFormValues.name"
            #name="ngModel"
          />
          @if (name.invalid && (name.dirty || name.touched)){
          <div class="alert">
            @if(name.hasError('required')){
            <div>
              {{ "home.form.nameError" | translate }}
            </div>
            } @if (name.hasError('minlength')) {
            <div>
              {{ "home.form.nameLength" | translate }}
            </div>
            }
          </div>
          }
        </div>
        <label for="email">Email:</label>
        <div>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="{{ 'home.form.emailPlaceholder' | translate }}"
            required
            [(ngModel)]="contactFormValues.email"
            #email="ngModel"
            email="true"
          />
          @if (email.invalid && (email.dirty || email.touched)){
          <div class="alert">
            @if(email.hasError('required')){
            <div>
              {{ "home.form.emailError" | translate }}
            </div>
            } @if (email.hasError('email')) {
            <div>
              {{ "home.form.invError" | translate }}
            </div>
            }
          </div>
          }
        </div>
        <label for="message">{{ "home.form.message" | translate }}</label>
        <div>
          <textarea
            id="message"
            name="message"
            placeholder="{{ 'home.form.messagePlaceholder' | translate }}"
            rows="5"
            required
            [(ngModel)]="contactFormValues.message"
            #message="ngModel"
          ></textarea>

          @if (message.invalid && (message.dirty || message.touched)){
          <div class="alert">
            @if(message.hasError('required')){
            <div>
              {{ "home.form.messageError" | translate }}
            </div>
            }
          </div>
          }
        </div>

        <div
          [ngClass]="{
            hidden: !showAlert
          }"
        >
          <p [ngClass]="alertColor" class="font-semibold">
            {{ alertMessage }}
          </p>
        </div>

        <button [disabled]="contactForm.invalid || onSubmit" type="submit">
          <ng-container *ngIf="onSubmit === false"> </ng-container>

          {{ "home.form.submit" | translate }} →
        </button>
      </form>
    </div>
  </div>
  <div class="bottom-about-private">
    {{ "home.form.rodo" | translate }}
  </div>
</section>
